export const formModes = {
  View: {
    label: 'VIENDO',
    readOnly: true,
  },
  Edit: {
    label: 'EDITANDO',
    readOnly: false,
  },
  Review: {
    label: 'REVISANDO',
    readOnly: true,
  },
  Disable: {
    label: 'DESHABILITADO',
    readOnly: true,
  },
} as const

export const findingsTypes = {
  Observation: 0,
  NonComplaintToFix: 1,
  NonComplaintSevere: 2,
}

export const PROGRAMS = {
  0: 'SARA',
  1: 'POA',
  2: 'RETERRA',
}

export const PROGRAM_IDS = {
  SARA: 0,
  POA: 1,
  RETERRA: 2,
}

export const metricEventStatus = {
  Open: 0,
  Close: 1,
}

export const LAND_PLAN_YEAR = 'LP'

export const monitoringTaskStatusTypes = {
  Pending: 0,
  InProgress: 1,
  Finished: 2,
  Cancelled: 3,
  Omitted: 4,
}

export const monitoringWorkflowsTypes = {
  SOC: 0,
  SOCPOA: 3,
  SOCRETERRA: 5,
  SOCV2: 6,
}

export const GEOMAN_OPTIONS = {
  limitMarkersToCount: 50,
}

export const randomizerVersions = {
  V1: '1.0.0',
  V2: '2.0.0',
  V3: '3.0.0',
  V4: '4.0.0',
} as const

export const COLORS = {
  GREEN: '#4CAF50',
  GRAY: '#757575',
  CARBON_INSTANCE: '#FF00FF',
} as const

export const PANEL_HEIGHT_VALUE_PX = 98
export const PANEL_HEIGHT = `calc(100vh - ${PANEL_HEIGHT_VALUE_PX}px)`

export const EXCLUSION_AREA_TYPE_IDS = {
  OTHER: '99',
}

// Mirrors ruuts-api's src/utils/constants.js MINIMUM_PADDOCK_AREA. No live API/config
// endpoint exposes this value today (it is a server-side validation constant, not part of
// programConfig) — kept as a single named frontend constant instead of a literal duplicated
// per call site so both sides stay easy to keep in sync intentionally.
export const MINIMUM_PADDOCK_AREA = 0.1
